import React, { useState, useEffect } from "react";
import { defer } from "rxjs";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";
import { DataGrid } from "@mui/x-data-grid";
import Header from "../../components/Header";
import { NavBar } from "../../components/NavBar";
import DocenteModal from "./DocenteModal";
import { getDocentesList } from "../../services/usuarios.service";
import HeaderActions from "../../components/Header-actions";
import Tooltip from "@mui/material/Tooltip";

const Docentes = () => {
  const [itemsList, setItemsList] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemSelected, setItemSelected] = useState({});
  const handleModal = (cell) => {
    setItemSelected(cell.row);
    setIsModalOpen(true);
  };

  useEffect(() => {
    const subscription = defer(() => getDocentesList()).subscribe((list) => {
      setItemsList(list);
      setLoading(false);
    });
    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const localRefresh = async (updatedItem) => {
    setLoading(true);
    const idxToRefresh = itemsList.findIndex((c) => c.id === updatedItem.id);
    let updatedList = [];
    if (idxToRefresh > -1) {
      updatedList = [
        ...itemsList.slice(0, idxToRefresh),
        updatedItem,
        ...itemsList.slice(idxToRefresh + 1),
      ];
    } else {
      updatedList = [...itemsList, updatedItem];
    }
    setItemsList(updatedList);
    setLoading(false);
  };

  const fullRefresh = () => {
    setLoading(true);
    getDocentesList().then((list) => {
      setItemsList(list);
      setLoading(false);
    });
  };

  const columns = [
    {
      field: "profileURL",
      headerName: "Foto",
      width: 60,
      renderCell: (params) => {
        return <Avatar alt="Foto de perfil" src={params.row.profileURL} />;
      },
    },
    {
      field: "nombre",
      headerName: "Nombre",
      width: 280,
      renderCell: (params) => {
        return (
          <Tooltip title={`${params.row.nombre} ${params.row.apellidos}`}>
            <strong>{`${params.row.nombre} ${params.row.apellidos}`}</strong>
          </Tooltip>
        );
      },
    },
    {
      field: "correo",
      headerName: "Correo",
      width: 220,
      renderCell: (params) => {
        return (
          <Tooltip title={params.row.correo}>
            <span>{params.row.correo}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "lugar",
      headerName: "Lugar",
      width: 120,
      align: "left",
    },
    {
      field: "centros",
      headerName: "Centros",
      width: 220,
      renderCell: (params) => {
        const centros = params.row.centros?.join(", ");
        return (
          <Tooltip title={centros}>
            <span>{centros}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "recursos",
      headerName: "Recursos",
      width: 80,
      align: "center",
    },
    {
      field: "recursos_disponibles",
      headerName: "Disponibles",
      width: 100,
      align: "center",
      renderCell: (params) => {
        return (
          <Tooltip title={params.row.recursos_disponibles?.join(", ")}>
            <Chip
              label={params.row.recursos_disponibles?.length}
              size="small"
              variant="outlined"
            />
          </Tooltip>
        );
      },
    },
  ];

  return (
    <Box sx={{ display: "flex", mt: 4, mb: 4 }}>
      <NavBar selected="Docentes" />
      <Container maxWidth="lg">
        <Header title="Docentes" subtitle="Listado de Docentes" />
        <HeaderActions refresh={fullRefresh} />
        <DocenteModal
          item={itemSelected}
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
          refresh={localRefresh}
        />
        <DataGrid
          rows={itemsList}
          columns={columns}
          sx={{ width: "100%", height: 600 }}
          loading={isLoading}
          autoHeight
          pageSize={15}
          rowsPerPageOptions={[15]}
          onCellClick={handleModal}
        />
      </Container>
    </Box>
  );
};

export default Docentes;
